import createMetadataAPIReducer from '../../utils/api-metadata-reducer';
import createMetadataAPIActions from '../../utils/api-metadata-actions';
import selectors from './selectors';
import { operations } from './operations';

const options = {
  name: 'dutyExchanges',
  baseType: 'DUTY_EXCHANGES',
  apiEndpoint: 'duty_exchanges',
  transform: t => ({ ...t, type: 'duty_exchange' })
};

const actions = createMetadataAPIActions(options);

export { operations, selectors, actions };
export default createMetadataAPIReducer(options);
